<div class="container">
    <div class="generic-container structure-container">
        <div class="left-panel">
            <div class="aspect-wrapper">
                <designer [isViewMode]="true" [isGlb]="isGlb"></designer>
            </div>

            <div class="preview" *ngIf="captureImages.length || loading">
                <div *ngFor="let img of captureImages; let i = index" class="preview-item">
                    <div class="preview-image">
                        <img [src]="img" [alt]="'Image' + (i + 1)" />
                    </div>
                    <div class="button-group">
                        <app-button variant="ghost" (click)="openDialogImage(img)">Preview</app-button>
                        <div class="divider"></div>
                        <app-button
                            variant="ghost"
                            (click)="removeImageFromS3(i)"
                            *ngIf="structure.status === structureStatus.Published"
                            >Delete</app-button
                        >
                    </div>
                </div>

                <div *ngIf="loading" class="spinner-overlay">
                    <mat-spinner diameter="45"></mat-spinner>
                </div>
            </div>
        </div>

        <div class="right-panel">
            <div class="product-info">
                <form [formGroup]="structureForm">
                    <!-- Structure Name -->
                    <div class="form-group">
                        <label for="structureName" class="product-name-label"
                            >{{ "structure.label.name" | translate }}:<span class="required">*</span></label
                        >
                        <input
                            id="structureName"
                            formControlName="structureName"
                            class="product-name"
                            required
                            [readOnly]="isReadOnly"
                        />
                    </div>
                    <!-- Description -->
                    <div class="form-group">
                        <label for="structureDescription" class="description-label"
                            >{{ "structure.label.description" | translate }}:<span class="required">*</span></label
                        >
                        <textarea
                            id="structureDescription"
                            formControlName="structureDescription"
                            class="description"
                            rows="3"
                            [readOnly]="isReadOnly"
                        ></textarea>
                    </div>
                    <!-- Actual Price  -->
                    <div class="form-group">
                        <label for="actualPrice" class="actual-price-label"
                            >{{ "structure.label.price" | translate }}:<span class="required">*</span></label
                        >
                        <input
                            id="actualPrice"
                            formControlName="actualPrice"
                            class="actualPrice"
                            type="number"
                            required
                            [readOnly]="isReadOnly"
                        />
                        <div
                            *ngIf="
                                structureForm.get('actualPrice')?.hasError('nonNegative') &&
                                structureForm.get('actualPrice')?.touched
                            "
                        >
                            <small class="error-text"
                                >{{ "structure.label.price" | translate }}
                                {{ "structure.invalidMessage.priceNegativeInvalid" | translate }}</small
                            >
                        </div>
                    </div>
                    <!-- Discount Price -->
                    <div class="form-group">
                        <label for="discountedPrice" class="discounted-price-label"
                            >{{ "structure.label.discountedPrice" | translate }}:</label
                        >
                        <input
                            id="discountedPrice"
                            formControlName="discountedPrice"
                            class="discountedPrice"
                            type="number"
                            [readOnly]="isReadOnly"
                        />
                        <div
                            *ngIf="
                                structureForm.get('discountedPrice')?.hasError('nonNegative') &&
                                structureForm.get('discountedPrice')?.touched
                            "
                        >
                            <small class="error-text"
                                >{{ "structure.label.discountedPrice" | translate }}
                                {{ "structure.invalidMessage.priceNegativeInvalid" | translate }}</small
                            >
                        </div>
                        <div
                            *ngIf="
                                structureForm.hasError('discountedPriceInvalid') &&
                                structureForm.get('discountedPrice')?.touched
                            "
                            class="text-red"
                        >
                            <small small class="error-text">{{
                                "structure.invalidMessage.discountedPriceInvalid" | translate
                            }}</small>
                        </div>
                    </div>
                    <!-- Model 3D JSON -->
                    <div class="form-group">
                        <label for="model3DJson" class="model3dJson-label"
                            >{{ "structure.label.model3DJson" | translate }}:</label
                        >
                        <textarea
                            id="model3DJson"
                            formControlName="model3DJson"
                            (blur)="onModel3DJsonBlur($event)"
                            class="model3dJson"
                            rows="3"
                            readonly
                        ></textarea>
                        <div
                            *ngIf="
                                structureForm.get('model3DJson')?.errors?.['invalidJson'] &&
                                structureForm.get('model3DJson')?.touched
                            "
                            class="text-red"
                        >
                            {{ "structure.invalidMessage.jsonInvalid" | translate }}
                        </div>
                    </div>

                    <!-- Model Quantity JSON -->
                    <div class="form-group">
                        <label for="modelQuantityJson" class="modelQuantityJson-label"
                            >{{ "structure.label.modelQuantityJson" | translate }}:</label
                        >
                        <textarea
                            id="modelQuantityJson"
                            formControlName="modelQuantityJson"
                            class="modelQuantityJson"
                            rows="3"
                            readonly
                        ></textarea>
                    </div>

                    <!-- blocks Quantity -->
                    <div class="form-group">
                        <label for="blocksQuantity" class="blocks-quantity-label"
                            >{{ "structure.label.blockQuantity" | translate }}:</label
                        >
                        <input
                            id="blocksQuantity"
                            formControlName="blocksQuantity"
                            class="blocks-quantity"
                            [value]="structureForm.get('blocksQuantity')?.value"
                            readonly
                        />
                    </div>

                    <!-- Category -->
                    <div class="form-group">
                        <label for="category" class="category-label"
                            >{{ "structure.label.category" | translate }}:<span class="required">*</span></label
                        >
                        <input
                            *ngIf="isReadOnly"
                            class="category"
                            mat-input
                            formControlName="category"
                            [readonly]="isReadOnly"
                        />
                        <mat-select *ngIf="!isReadOnly" formControlName="category" multiple class="category">
                            <mat-option *ngFor="let category of categories" [value]="category">
                                {{ category }}
                            </mat-option>
                        </mat-select>
                    </div>
                    <!-- Sub-Category -->
                    <div class="form-group">
                        <label for="SubCategory" class="category-label"
                            >{{ "structure.label.subCategory" | translate }}:<span class="required">*</span></label
                        >
                        <input
                            *ngIf="isReadOnly"
                            class="category"
                            mat-input
                            formControlName="subCategory"
                            [readonly]="isReadOnly"
                        />
                        <mat-select *ngIf="!isReadOnly" formControlName="subCategory" class="category">
                            <mat-option *ngFor="let SubCategory of commonSubcategories" [value]="SubCategory">
                                {{ SubCategory }}
                            </mat-option>
                        </mat-select>
                    </div>
                    <!-- GST Rate -->
                    <div class="form-group">
                        <label for="gstRate" class="gstRate-label"
                            >{{ "structure.label.gstRate" | translate }} (%):</label
                        >
                        <input
                            *ngIf="isReadOnly"
                            class="gstRate"
                            mat-input
                            formControlName="gstRate"
                            [readonly]="isReadOnly"
                        />
                        <mat-select id="gstRate" *ngIf="!isReadOnly" formControlName="gstRate" class="gstRate">
                            <mat-option *ngFor="let rate of gstRates" [value]="rate">{{ rate }}% </mat-option>
                        </mat-select>
                    </div>
                </form>

                <div class="btnContainer" *ngIf="structure?.status === structureStatus.Published">
                    <button
                        mat-flat-button
                        class="btn-primary-gradient"
                        [disabled]="!isCheckApprove()"
                        (click)="approveStructure()"
                    >
                        {{ "structure.button.approveBtn" | translate }}
                    </button>
                    <button mat-flat-button class="btn-secondary-gradient" (click)="rejectStructure()">
                        {{ "structure.button.rejectBtn" | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
